import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sensitive_info",
  "use": "sensitive_info-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"sensitive_info\"><path d=\"M11 0H0v13h11zM7 10H2V9h5zm2-3H2V6h7zm0-3H2V3h7z\" /><path d=\"M12 2v12H2v2h12V2h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id